import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';
import { closest } from 'next/javascripts/modules/dom';
import 'next/stylesheets/components/project/attachment-center/list.scss';

Component('tr-project-attachment-center-list', {
  mixins: [eventListenerMixin],

  properties: {
    scrollLoadUrl: String,
    keyword: String,
    kind: String,
    page: Number,
  },

  ready() {
    this.kindFilter = this.querySelector('.kind-filter');
    this.searchInput = this.querySelector('.search-input input');
    this.scrollLoadTrigger = this.querySelector('tr-scroll-load-trigger');
    this.listenTo(this.kindFilter, 'click', this.handleKindClick.bind(this));
    this.listenTo(this.searchInput, 'keydown', this.handleSearch.bind(this));
    if (!this.scrollLoadUrl || !this.scrollLoadTrigger) return;
    this.listenTo(this.scrollLoadTrigger, {
      'tr-scroll-load-trigger:loading': this.loadMore.bind(this),
    });
  },

  handleKindClick(event) {
    const item = closest(event.target, '.attachment-type');
    if (!item || item.classList.contains('selected')) return;

    const url = new URL(window.location.href);
    url.searchParams.set('kind', item.dataset.kind);
    window.tower.stack.load(url, { replace: true });
  },

  handleSearch(event) {
    if (event.which !== 13) return;
    const url = new URL(window.location.href);
    url.searchParams.set('keyword', this.searchInput.value);
    window.tower.stack.load(url, { replace: true });
  },

  loadMore() {
    const data = { keyword: this.keyword, kind: this.kind };
    if (this.keyword) {
      data.page = this.page + 1;
    } else {
      data.till = this.querySelector('.results .day:last-of-type').dataset.date;
    }
    $.ajax({
      url: this.scrollLoadUrl,
      method: 'GET',
      dataType: 'script',
      data,
    });
  },
});
